import React, { useContext, useReducer } from "react";
import axios from "axios";
import reducer from "./reducer";

const initialState = {
  isLoading: false,
  nfts: [],
  nft: null,
  sellers: [],
  seller: null,
};

const AppContext = React.createContext();

const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const setLoading = () => {
    dispatch({ type: "SET_LOADING" });
  };

  const fetchNfts = async () => {
    setLoading();
    try {
      const { data: nfts } = await axios.get(
        `https://60d1258d7de0b2001710a1cb.mockapi.io/nfts`
      );
      dispatch({ type: "FETCH_NFTS_SUCCESS", payload: nfts });
    } catch (error) {
      dispatch({ type: "FETCH_NFTS_ERROR" });
    }
  };

  const fetchSellers = async () => {
    setLoading();
    try {
      const { data: sellers } = await axios.get(
        `https://60d1258d7de0b2001710a1cb.mockapi.io/seller`
      );
      dispatch({ type: "FETCH_SELLERS_SUCCESS", payload: sellers });
    } catch (error) {
      dispatch({ type: "FETCH_SELLERS_ERROR" });
    }
  };

  const fetchSingleSeller = async (sellerId) => {
    setLoading();
    try {
      const { data: seller } = await axios.get(
        `https://60d1258d7de0b2001710a1cb.mockapi.io/seller/${sellerId}`
      );
      dispatch({ type: "FETCH_SINGLE_SELLER_SUCCESS", payload: seller });
    } catch (error) {
      dispatch({ type: "FETCH_SINGLE_SELLER_ERROR" });
    }
  };

  const fetchSingleNft = async (nftId) => {
    setLoading();
    try {
      const { data: nft } = await axios.get(
        `https://60d1258d7de0b2001710a1cb.mockapi.io/nfts/${nftId}`
      );
      dispatch({ type: "FETCH_SINGLE_NFT_SUCCESS", payload: nft });
    } catch (error) {
      dispatch({ type: "FETCH_SINGLE_NFT_ERROR" });
    }
  };

  return (
    <AppContext.Provider
      value={{
        ...state,
        setLoading,
        fetchNfts,
        fetchSingleNft,
        fetchSellers,
        fetchSingleSeller,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

// make sure use
export const useGlobalContext = () => {
  return useContext(AppContext);
};

export { AppProvider };
